module.exports = __webpack_public_path__ + "images/userIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/userIcon.png
// module id = 2125
// module chunks = 0